/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Dropdown } from 'carbon-components-react';
import cx from 'classnames';
import { useIntl, FormattedMessage } from 'react-intl';

import { selectIsInsightActionsEnabled } from '@ibm-watson/shared/modules/ia/store/features/selectors';
import { useAppSelector } from '../../../../store';
import { messages as ConfigOptionMessages } from '../../../discovery/components/search-detail-config/messages';

import './Citations.scss';
export interface CitationsProps {
  draft: {
    setMaxCitationsValue: (number) => void;
    isConversationalSearchEnabled: boolean;
    maxCitationsValue: number;
  };
  readOnly: boolean;
}

export const Citations = ({ draft, readOnly }: CitationsProps) => {
  const { formatMessage: t } = useIntl();
  const isInsightActionsEnabled = useAppSelector(selectIsInsightActionsEnabled);
  const convoSearchEnabledReadonly =
    !draft.isConversationalSearchEnabled || readOnly;
  const citationItems = [
    {
      id: '-1',
      text: t(ConfigOptionMessages.citationsAll),
      value: -1
    },
    {
      id: '3',
      text: t(ConfigOptionMessages.citations3),
      value: 3
    },
    {
      id: '2',
      text: t(ConfigOptionMessages.citations2),
      value: 2
    },
    {
      id: '1',
      text: t(ConfigOptionMessages.citations1),
      value: 1
    },
    {
      id: '0',
      text: t(ConfigOptionMessages.citationsNone),
      value: 0
    }
  ];
  const onCitationChange = item => {
    draft.setMaxCitationsValue(item.selectedItem.value);
  };

  return (
    <>
      {isInsightActionsEnabled && (
        <div className="Citations ">
          <h4 className="Citations-title">
            {t(ConfigOptionMessages.citations)}
          </h4>
          <div
            className={cx('Citations-description', {
              'ConfigureContent__multiturnDescription--disabled':
                convoSearchEnabledReadonly
            })}>
            <FormattedMessage {...ConfigOptionMessages.citationsDescription} />
          </div>
          <div className="Citations-dropdown">
            <Dropdown
              id="citations-dropdown"
              titleText={t(ConfigOptionMessages.citationsLabel)}
              label={t(ConfigOptionMessages.citationsLabel)}
              selectedItem={citationItems.find(
                item => item.value === draft.maxCitationsValue
              )}
              items={citationItems}
              itemToString={item => (item ? item.text : '')}
              onChange={onCitationChange}
              disabled={convoSearchEnabledReadonly}
            />
          </div>
        </div>
      )}
    </>
  );
};
